import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "alertSeverity" })
export class AlertSeverityPipe implements PipeTransform {
  // We determine severity in airbrake-app the same way so that we can provide
  // the right color and severity for the spike.
  // https://github.com/airbrake/airbrake-app/blob/af3cad2/app/models/anomaly_notification.rb#L46-L58
  public transform(alert: any) {
    // Ratio anomaly values are between 0 and 1 so we multiply them by 10000.
    // If not, even a spike of 99% will be reported as 'Minor'.
    const multiplier = alert.activity.startsWith("route.ratio") ? 10000 : 100;
    const difference = Math.abs(
      (alert.params.value - alert.params.mean) * multiplier,
    );

    if (difference > 5000) {
      return "Major";
    } else if (difference > 2500) {
      return "Moderate";
    } else {
      return "Minor";
    }
  }
}
